"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.UndoableIterator = void 0;
var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var UndoableIterator = /*#__PURE__*/function () {
  function UndoableIterator() {
    (0, _classCallCheck2["default"])(this, UndoableIterator);
    this.list = [];
    this._currentIndex = null;
    this._lastPresent = null;
  }
  (0, _createClass2["default"])(UndoableIterator, [{
    key: "push",
    value: function push(item) {
      var _context;
      if (item === null || item === undefined) throw 'Cannot push null or undefined item';
      if (!isNaN(this._currentIndex) && this._currentIndex < this.list.length - 1) (0, _splice["default"])(_context = this.list).call(_context, this._currentIndex + 1, this.list.length - (this._currentIndex + 1));
      this.list.push(item);
      this._currentIndex = this.list.length - 1;
    }
  }, {
    key: "next",
    value: function next() {
      this._lastPresent = this.list[this._currentIndex];
      if (this.hasNext()) this._currentIndex++;
    }
  }, {
    key: "prev",
    value: function prev() {
      this._lastPresent = this.list[this._currentIndex];
      if (this.hasPrev()) this._currentIndex--;
    }
  }, {
    key: "getPresent",
    value: function getPresent() {
      if (this._currentIndex === null) throw 'List is empty';
      return this.list[this._currentIndex];
    }
  }, {
    key: "isInvalidUndo",
    value: function isInvalidUndo() {
      return this._currentIndex === 0 && this.getPresent() === this._lastPresent;
    }
  }, {
    key: "isInvalidRedo",
    value: function isInvalidRedo() {
      return this._currentIndex === this.list.length - 1 && this.getNext() === this._lastPresent;
    }
  }, {
    key: "getNext",
    value: function getNext() {
      return !!this.list[this._currentIndex + 1] ? this.list[this._currentIndex + 1] : null;
    }
  }, {
    key: "getPrev",
    value: function getPrev() {
      return !!this.list[this._currentIndex - 1] ? this.list[this._currentIndex - 1] : null;
    }
  }, {
    key: "hasNext",
    value: function hasNext() {
      if (this._currentIndex === null) return false;else {
        var nextIndex = this._currentIndex + 1;
        return !!this.list[nextIndex];
      }
    }
  }, {
    key: "hasPrev",
    value: function hasPrev() {
      if (this._currentIndex === null) return false;else {
        var prevIndex = this._currentIndex - 1;
        return !!this.list[prevIndex];
      }
    }
  }]);
  return UndoableIterator;
}();
exports.UndoableIterator = UndoableIterator;
//# sourceMappingURL=UndoIterable.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/patterns/UndoIterable.js
// module id = 1144
// module chunks = 142